import './App.css';
import React from 'react';
import PgsPage from './screens/PgsPage';
import BookingPage from './screens/BookingPage';
import NothelferPage from './screens/NothelferPage';
import VkuCalendarPage from './screens/VkuCalendarPage';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import DrivingAttendantCoursePage from './screens/DrivingAttendantCoursePage';
import MotorcycleTrainingCoursePage from './screens/MotorcycleTrainingCoursePage';

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route path={'/vku-calendar'} component={VkuCalendarPage} exact />

        <Route path={'/vku'} component={VkuCalendarPage} exact />
        <Route path={'/pgs'} component={PgsPage} exact />
        <Route path={'/nothelfer'} component={NothelferPage} exact />
        <Route path={'/motorrad-weiterbildungskurs'} component={MotorcycleTrainingCoursePage} exact />
        <Route path={'/fahrbegleiterkurs'} component={DrivingAttendantCoursePage} exact />

        <Route path={'/:type/booking'} component={BookingPage} exact />
      </Switch>
    </Router>
  );
}

export default App;
